import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@store/authStore'

export default function LoginPage() {
  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [showPwd,  setShowPwd]  = useState(false)
  const { login, isLoading, error } = useAuthStore()
  const navigate = useNavigate()

  const handleSubmit = async () => {
    await login(email, password)
    if (useAuthStore.getState().token) navigate('/app/dashboard')
  }
  const handleKey = (e) => { if (e.key === 'Enter') handleSubmit() }

  const inputStyle = (hasError) => ({
    width: '100%',
    padding: '13px 16px',
    border: `1.5px solid ${hasError ? '#fca5a5' : '#d1d5db'}`,
    borderRadius: 8,
    fontSize: 15,
    outline: 'none',
    boxSizing: 'border-box',
    color: '#111827',
    background: 'white',
    transition: 'border-color .15s',
    fontFamily: 'inherit',
  })

  return (
    <div style={{
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f9fafb',
      fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',
      padding: '24px 16px',
    }}>

      {/* Title */}
      <h1 style={{
        fontSize: 28,
        fontWeight: 800,
        color: '#111827',
        margin: '0 0 28px',
        textAlign: 'center',
        letterSpacing: -0.3,
      }}>
        Đăng nhập vào tài khoản
      </h1>

      {/* Card */}
      <div style={{
        background: 'white',
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        padding: '28px 32px',
        width: '100%',
        maxWidth: 420,
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>

          {/* Email field */}
          <div>
            <label style={{
              fontSize: 14, fontWeight: 600, color: '#374151',
              display: 'block', marginBottom: 6,
            }}>
              Địa chỉ email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={handleKey}
              placeholder="Nhập email của bạn"
              style={inputStyle(!!error)}
              onFocus={e => e.target.style.borderColor = '#059669'}
              onBlur={e  => e.target.style.borderColor = error ? '#fca5a5' : '#d1d5db'}
            />
          </div>

          {/* Password field */}
          <div>
            <label style={{
              fontSize: 14, fontWeight: 600, color: '#374151',
              display: 'block', marginBottom: 6,
            }}>
              Mật khẩu
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPwd ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={handleKey}
                placeholder="Nhập mật khẩu"
                style={{ ...inputStyle(!!error), paddingRight: 44 }}
                onFocus={e => e.target.style.borderColor = '#059669'}
                onBlur={e  => e.target.style.borderColor = error ? '#fca5a5' : '#d1d5db'}
              />
              <button
                onClick={() => setShowPwd(p => !p)}
                style={{
                  position: 'absolute', right: 12, top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer',
                  fontSize: 15, color: '#9ca3af', padding: 0, lineHeight: 1,
                }}
                tabIndex={-1}
              >{showPwd ? '🙈' : '👁'}</button>
            </div>
          </div>

          {/* Error */}
          {error && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fca5a5',
              borderRadius: 7, padding: '9px 12px',
              fontSize: 13, color: '#dc2626',
              display: 'flex', alignItems: 'center', gap: 6,
            }}>
              ⚠ {error}
            </div>
          )}

          {/* Forgot password */}
          <div style={{ textAlign: 'right', marginTop: -8 }}>
            <a
              href="#"
              style={{ fontSize: 13, color: '#2563eb', textDecoration: 'none', fontWeight: 500 }}
              onMouseEnter={e => e.target.style.textDecoration = 'underline'}
              onMouseLeave={e => e.target.style.textDecoration = 'none'}
            >
              Quên mật khẩu?
            </a>
          </div>

          {/* Submit button */}
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '13px',
              background: isLoading ? '#93c5fd' : '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              fontSize: 15,
              fontWeight: 700,
              cursor: isLoading ? 'not-allowed' : 'pointer',
              letterSpacing: 0.2,
              transition: 'background .15s',
              fontFamily: 'inherit',
            }}
            onMouseEnter={e => { if (!isLoading) e.target.style.background = '#1d4ed8' }}
            onMouseLeave={e => { if (!isLoading) e.target.style.background = '#2563eb' }}
          >
            {isLoading ? 'Đang đăng nhập…' : 'Đăng nhập'}
          </button>
        </div>
      </div>

      {/* Register link */}
      <p style={{ marginTop: 20, fontSize: 14, color: '#6b7280' }}>
        Chưa có tài khoản?{' '}
        <a href="#" style={{ color: '#2563eb', fontWeight: 600, textDecoration: 'none' }}
          onMouseEnter={e => e.target.style.textDecoration = 'underline'}
          onMouseLeave={e => e.target.style.textDecoration = 'none'}>
          Đăng ký
        </a>
      </p>

      {/* Privacy policy */}
      <a
        href="https://privacy-policy.greenarrows.energy/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          marginTop: 10, fontSize: 13, color: '#6b7280',
          textDecoration: 'underline', textUnderlineOffset: 2,
        }}
      >
        Chính sách bảo mật
      </a>

      {/* Footer */}
      <p style={{ marginTop: 24, fontSize: 11, color: '#9ca3af' }}>
        © 2026 Green Arrows Energy · EMS v2.5
      </p>
    </div>
  )
}
